import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8af5d466"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-p-[40px] tw-bg-white" }
const _hoisted_2 = { class: "tw-text-[18px] tw-font-[600] tw-text-[#211F58]" }
const _hoisted_3 = { class: "tw-ml-[10px]" }
const _hoisted_4 = { class: "tw-mt-[10px] tw-text-[#878787] tw-text-[13px] tw-font-[400] tw-leading-[145%]" }
const _hoisted_5 = { class: "tw-mt-[40px] tw-p-[40px] tw-flex-col tw-gap-[13px] tw-items-start tw-justify-center box-shadow tw-rounded-[4px] tw-border tw-border-solid tw-border-[#EFF0F1] tw-bg-[#F7F7F8]" }
const _hoisted_6 = { class: "tw-text-[18px] tw-font-[600] tw-text-[#211F58] tw-mb-[10px]" }
const _hoisted_7 = ["innerHTML"]

import CopyInfo from "@/components/common/copyInfo.vue";
import { getComponentUiText } from "@/utils/utilities";
import ButtonShowDuplicateAssessment from "../common/setting/buttonShowDuplicateAssessment.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'createNewVendorAssessmentCompleteSection',
  props: {
  secret: {
    type: String,
    required: true,
  },
},
  emits: [
  "update:show",
  "update:domain",
  "delete:domain",
  "update:close",
],
  setup(__props, { emit }) {


const hintTex = getComponentUiText(
  "app-modal-create-a-new-vendor-assessment-complete-section-helper-text-1",
  false,
  {
    completeText: {
      value: `'${getComponentUiText(
        "app-profile-modal-update-email-address-button-1",
      )}'`,
      css: "tw-text-[#231F20] tw-font-[600]",
    },
  },
);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
          "app-modal-create-a-new-vendor-assessment-complete-section-subtitle-1",
        )) + " ", 1),
      _createElementVNode("span", _hoisted_3, [
        _createVNode(ButtonShowDuplicateAssessment, { "id-popover": 'popover-vendor-assessment-complete-section' })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(getComponentUiText)(
          "app-modal-create-a-new-vendor-assessment-complete-section-hint-1",
        )), 1),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(getComponentUiText)(
            "app-modal-create-a-new-vendor-assessment-complete-section-secret-1",
          )), 1),
      _createElementVNode("div", {
        class: "tw-text-[#231F20] tw-text-[15px] tw-font-[400] tw-leading-[145%]",
        innerHTML: _unref(hintTex)
      }, null, 8, _hoisted_7),
      _createVNode(CopyInfo, {
        class: "!tw-max-w-[100%] !tw-w-[100%] tw-py-[14px] tw-mt-[25px] tw-px-[20px] tw-bg-[#FFFFFF] tw-rounded-md",
        text: __props.secret,
        "style-icon-css": 'tw-w-[18px] tw-h-[18px]',
        "text-class": "tw-text-[15px] tw-font-[400] tw-leading-[145%] tw-text-[#231F20]",
        "alert-class": "!tw-right-[50px] !tw-top-[40px]"
      }, null, 8, ["text"])
    ])
  ]))
}
}

})